import { IAccumulatedData } from "./IAccumulatedData";

export enum EventType {
    HarshBraking = 1,
    OverRpm = 2,
    Unknown3 = 3,
    Pto = 4,
    OverTorque = 8,
    BadAnticipation = 16,
    Idling = 32,
    OverAcceleration = 64
}

export enum EventFlag {
    End,
    Start,
}

export interface ISensorData extends IAccumulatedData {
    PlotId: number;
    VehicleId?: number;
    Utc: Date;
    Header: string;
    Profile: string;
    ExtendedInfo: string;
    BatteryLevel?: number;
    CruiseActive?: boolean;
    EngineRpm?: number;
    EventType?: EventType;
    EventFlag?: EventFlag;
    EventEntryValue?: number;
    EventExitValue?: number;
    EventMaxValue?: number;
    EventDuration?: number;
    FuelLevel?: number;
    OdometerKm?: number;
    PrimaryAuxBatteryVoltage?: number;
    PrimaryAuxEngineFuelLevel?: number;
    PrimaryAuxElectricOnDuration?: number; // Given in seconds
    PrimaryAuxEngineOnDuration?: number; // Given in seconds
    PrimaryAuxEngineSource?: number;
    PrimaryAuxStandbyOnDuration?: number; // Given in seconds
    PtoActive?: boolean;
    TachoSlot1Driver: string;
    TachoSlot1WorkState?: number;
    TachoSlot1TimeState?: number;
    TachoSlot1DrivingTime?: number;
    TachoSlot2Driver: string;
    TachoSlot2WorkState?: number;
    TachoSlot2TimeState?: number;
    TachoSlot2DrivingTime?: number;
    ThrottlePosition?: number;
    TotalWeight?: number;
    TrailerId: string;
    TrailerConnected?: boolean;
    VehicleIdentificationNumber: string;
    Velocity?: number;
    VelocityMax?: number;
}
